<template>
    <div id="cams" class="cams">
        <div class="camWrap" v-if="selectedCam.name" @click="clearCam">
          <div class="camsView">
              <img class="photo" v-bind:src="storageUrl + 'cameras/' + selectedCam.name + '.jpg'" alt="">
          </div>
        </div>
        <div class="camsViewGallery">
          <div v-for="cam in cams" v-bind:key="cam.name" @click="changeCam(cam)">
            <img class="photo" v-bind:src="storageUrl + 'cameras/' + cam.name + '-thumb.jpg'" alt="">
            <p>{{cam.name}}</p>
          </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'camsview',
  props: [
    'selectedCam',
    'changeCam'
  ],
  mounted: function () {
    this.getCameras().then(() => {
      this.loading = false
    })
  },
  data: function () {
    return {
      loading: true
    }
  },
  computed: {
    cams: function () {
      return this.$store.getters.cameras
    },
    storageUrl: function () {
      return this.$store.getters.storageEndpoint
    }
  },
  methods: {
    ...mapActions(['getCameras']),
    clearCam: function () {
      this.changeCam({})
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/map/CamsView.vue